import jsPDF from "jspdf";
import "jspdf-autotable";
// Date Fns is used to format the dates we receive
// from our API call
import { format } from "date-fns";

// define a generatePDF function that accepts a tickets argument
const generatePDF = licensReport => {
  // initialize jsPDF
//   const doc = new jsPDF();
const doc = new jsPDF('l', 'mm', 'a4');
const d =      format(new Date(), "yyyy-MM-dd")
;
  // define the columns we want and their titles
  const tableColumn = ["Name","Email", "Plan Amount","Valid From Date","Valid To Date","Type of License","license Issued Date","license Status","License Url", "Pet License Number","Pet Name", "Pet Color", "Pet Breed", "Pet Gender","Pet Image Url"];
  // define an empty array of rows
  const tableRows = [];
  doc.text("License Report "+d, 14, 15);
  // for each report pass all its data into an array
  licensReport.forEach(report => {
    const paymentData = [
      report.userName ? report.userName : "N/A",
      report.email ?  report.email : "N/A",
      report.planAmount ? "$ "+ report.planAmount : "N/A",
      report.validFromDate ? report.validFromDate :"N/A",
      report.validToDate ? report.validToDate : "N/A",
      report.typeofLicense ? report.typeofLicense : "N/A",
      report.licenseIssuedDate ? report.licenseIssuedDate : "N/A",
      report.licenseStatus ? report.licenseStatus : "N/A",
      report.licenseUrl ? report.licenseUrl : "N/A",
      report.dogLicenseNumber ? report.dogLicenseNumber : "N/A",
      report.dogName ? report.dogName : "N/A",
      report.color ? report.color : "N/A",
      report.breed ? report.breed : "N/A",
      report.gender ? report.gender : "N/A",
      report.dogImageUrl ? report.dogImageUrl : "N/A",
      // called date-fns to format the date on the report
    ];
   
    tableRows.push(paymentData);
  });

  // startY is basically margin-top
  doc.autoTable(tableColumn, tableRows, { startY: 20, styles: {cellWidth: 18, fontSize: 8}});
  // we use a date string to generate our filename.
  // report title. and margin-top + margin-left
  // doc.text("License Report "+d, 14, 15);
  // we define the name of our PDF file.
  doc.save(`License_report_${d}.pdf`);
};

export default generatePDF;